import {
  setObject,
  checkVariable,
} from '../../plugins/helper'
import {
  createForm,
} from '../../plugins/helperService'

export const referenceContract = form => {
  const newForm = createForm(form)
  let { contrato } = newForm
  if (!checkVariable(contrato)) {
    contrato = ''
  }

  const table = contrato.split('-')
  if (table && Array.isArray(table) && table.length > 0) {
    if (table[0] === 'contrato_infras') {
      setObject(newForm, 'contrato_infra_id', table[1])
      setObject(newForm, 'contrato_id', '')
    } else {
      setObject(newForm, 'contrato_id', table[1])
      setObject(newForm, 'contrato_infra_id', '')
    }
  } else {
    setObject(newForm, 'contrato_id', '')
    setObject(newForm, 'contrato_infra_id', '')
  }

  return newForm
}
